import { DEFAULT_PHOTOGALLERY_IMAGE_RATIO } from "../../../components/PhotoGallery/constants";

export function photoGallery(
    contentId,
    contentStatus = "",
    aspectRatio = DEFAULT_PHOTOGALLERY_IMAGE_RATIO
) {
    return `
    query {
        contentItem(sourceId: "${contentId}", contentStatus:"${contentStatus}") {
            photoGallery {
              images {
                sourceId
                localDescription
                image {
                  credit                  
                  altText
                  aspects {
                    ratio${aspectRatio} {
                      url
                    }
                  }
                }
              }
            }
          }
        }
    `;
}
